import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Forces the window (and #root scroll container) back to the top on every
 * route change. Critical for mobile SPA UX where the browser preserves
 * scroll position across navigations.
 *
 * Uses useLayoutEffect + a follow-up rAF pass so the reset happens before
 * the first paint and again after any late layout shift from lazy content.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    // If a fragment identifier is present, let the browser handle it.
    if (hash) return undefined;

    const jump = () => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      } catch {
        window.scrollTo(0, 0);
      }
      const root = document.getElementById("root");
      if (root) root.scrollTop = 0;
      if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
    };

    jump();
    // Second pass after paint — catches layout shifts from lazy images/hero.
    const raf = requestAnimationFrame(jump);
    return () => cancelAnimationFrame(raf);
  }, [pathname, hash]);

  return null;
}
